export const token = `${process.env.REACT_APP_TOKEN}`;
export const hubApiBaseUrl = `${process.env.REACT_APP_HUB_API_BASE_URL}`;

export const errorMessage = "Error, something went wrong";
export const successMessage = "Action completed successfully";

export const notificationsTime = 3000;

export const defaultColor = "#4285F4";

export const googleOauthUrl = 'https://accounts.google.com/o/oauth2/v2/auth';
export const microsoftOauthUrl = 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize';
